import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import styled from "styled-components";

interface IconButtonProps {
  icon: IconDefinition;
  onClick: () => void;
  disabled?: boolean;
  title?: string;
  variant?: string;
  active?: boolean;
  className?: string;
}


const IconButton = ({
  icon,
  onClick,
  disabled,
  title,
  active,
  variant = "primary",
  className
}: IconButtonProps) => {
  return (
    <Button
      active={active}
      title={title}
      disabled={disabled}
      onClick={onClick}
      variant={variant}
      className={active? `btn-active ${className}` : className}
    >
      <FontAwesomeIcon icon={icon}></FontAwesomeIcon>
    </Button>
  );
};

export default IconButton;
